module.exports = __webpack_public_path__ + "static/media/p508hint.a0bf96e9.jpg";